import React from "react";
import { apiEndpoint } from "helpers/url_helper";
import ReactApexChart from "react-apexcharts"
import axios from "axios";
import { useEffect, useState } from 'react';
import { Card } from "reactstrap";
import {CardBody} from "reactstrap";
import {Row,Col} from "reactstrap";
const series=[];
const Barchart = props =>  {
  const [violations, setviolations] = useState([]);
  const [vehiclecount, setvehiclecount] = useState([]);
  const [locations, setlocations] = useState([]);
  const [violationCnt, setviolationCnt] = useState([]);
  const [vehicleCountNo, setvehicleCountNo] = useState([]);
  useEffect(() => {
    var intCampusID=props.CampusID;
    const getData = async () => {
      // UserValidated
    var url = apiEndpoint+'/GetDailyData';
  try {
    const response = await fetch(url, {
      method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              "intCampusID": intCampusID,
              "strToken": sessionStorage.getItem("Clear_AuthUser")
            })
    });
     if(response.body!=null){
    const data = await response.json();
   // console.log("Violations"+data.Violations);
  //  console.log("Vehicle Count"+data.VehicleCount);
  
    setviolations(JSON.parse(data.VehicleCount)?.map((item) => item.ViolationCount));
    setvehiclecount(JSON.parse(data.VehicleCount)?.map((item) => item.VehicleCount));
    setlocations(JSON.parse(data.VehicleCount)?.map((item) => item.LocationName));
    // console.log(JSON.parse(data.VehicleCount)?.map((item) => item.LocationName))
    // console.log(JSON.parse(data.Violations)?.map((item) => item.LocationName))

    setviolationCnt(data.violationsCnt)
    setvehicleCountNo(data.vehicleCnt)
     }
  } catch (error) {
      console.log(error);
  }
};
  getData();
}, [props.CampusID]);

  const options = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '30%',
        endingShape: 'rounded'

      },
    },
    stroke: {
      show: true,
      width: 3,
      colors: ['transparent']
    },
    dataLabels: {
      enabled: false,
    },

    colors: [ "#5D59AF", "#98D7C2"],
    grid: {
      borderColor: "#f8f8fa",
      row: {
        colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    legend: {
      show: true,
    },
    xaxis: {
      categories: locations
    }
  }
 

  return (
    <React.Fragment>   <Card className="m-b-20">
    <CardBody>
        <h4 className="card-title mb-4">Today's  Violations</h4>
        <div className="row text-center mt-4">
            <div className="col-sm-6">
                <h5 className="mb-0 font-size-20">{vehicleCountNo}</h5>
                <p className="text-muted">Vehicle Count</p>
            </div>
            <div className="col-sm-6">
                <h5 className="mb-0 font-size-20">{violationCnt}</h5>
                <p className="text-muted">Violation Count</p>
            </div>                              
        </div>
        <div id="chart" dir="ltr">
    <ReactApexChart options={options} series={[{
      name: 'Violations',
      data: violations
    },
    {
      name: 'Vehicle Count',
      data: vehiclecount
    }]} 
     type="bar" height="300" />
     </div>
     </CardBody>
     </Card>
     </React.Fragment>
  )
}

export default Barchart

